import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Check, FileText, ShoppingBag, Lightbulb } from "lucide-react";

const Package = () => {
  const scrollToCheckout = () => {
    const element = document.getElementById('checkout');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  const packageItems = [
    {
      icon: FileText,
      title: 'E-book "30 Receitas Express" (PDF)',
      description: "30 receitas detalhadas com tempo, rendimento, ingredientes, passo a passo, substituições e variações.",
    },
    {
      icon: ShoppingBag,
      title: "Lista de compras consolidada",
      description: "Planeje e compre todos os ingredientes de uma vez. Organize seu mês sem desperdício.",
    },
    {
      icon: Lightbulb,
      title: "Dicas e sugestões extras",
      description: "Acompanhamentos, aproveitamento de sobras e formas de servir para deixar o prato bonito e completo.",
    },
  ];

  return (
    <section id="pacote" className="py-16 lg:py-24 bg-muted/30">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            O que você recebe hoje
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Tudo que você precisa para transformar seus almoços
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid gap-6 mb-8">
            {packageItems.map((item, index) => {
              const Icon = item.icon;
              return (
                <Card 
                  key={index}
                  className="border-2 animate-slide-up"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <CardContent className="flex gap-4 p-6">
                    <div className="shrink-0">
                      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-gradient-warm">
                        <Icon className="h-6 w-6 text-white" />
                      </div>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                      <p className="text-muted-foreground">{item.description}</p>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="text-center">
            <Button 
              onClick={scrollToCheckout}
              size="lg"
              className="bg-gradient-warm hover:shadow-hover transition-all duration-300 text-lg h-14 px-8"
            >
              Garantir por R$ 29,90
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Package;
